<script>
export default {
  name: 'EpcStatus',
  props: ['status'],
  i18n: {
    messages: {
      de: {
        ACTIVE: 'Aktiv',
        INACTIVE: 'Inaktiv',
        DISCONTINUED: 'Inaktiv'
      },
      en: {
        ACTIVE: 'Active',
        INACTIVE: 'Inactive',
        DISCONTINUED: 'Inactive'
      }
    }
  }
}
</script>

<template>
  <span>
    {{ $t(status) }}
  </span>
</template>



// WEBPACK FOOTER //
// src/components/EpcStatus.vue